<template>
	<div :class="classes">
		<span
			v-if="showPercentOnLeft"
			class="teaming-progress-bar__percent teaming-progress-bar__percent--left"
		>{{ percentCompleted }}%</span>
		<span class="teaming-progress-bar__progress-bar">
			<span class="teaming-progress-bar__outer-bar">
				<span class="teaming-progress-bar__inner-bar" :style="completionStyle"></span>
				<span class="teaming-progress-bar__progress" v-if="showProgress" :style="progressionStyle"></span>
			</span>
		</span>
		<span
			v-if="showPercentOnRight"
			class="teaming-progress-bar__percent teaming-progress-bar__percent--right"
		>{{ percentCompleted }}%</span>
	</div>
</template>

<script>
import { Enum } from "@teaming/common-enums";

export const Position = Object.create( Enum );
Position.LEFT = "LEFT";
Position.RIGHT = "RIGHT";

export default {
	name: "TeamingProgressBar",
	props: {
		percentCompleted: {
			type: Number,
			default: 0,
		},
		percentProgressed: {
			type: Number,
			default: -1,
		},
		showProgress: {
			type: Boolean,
			default: true,
		},
		showPercent: {
			type: Boolean,
			default: true,
		},
		className: {
			type: String,
			default: "",
		},
		percentPosition: {
			type: String,
			validator( value ) {
				return Object.keys( Position ).indexOf( value ) !== -1;
			},
			default: Position.RIGHT,
		},
	},
	computed: {
		classes() {
			return {
				"teaming-progress-bar": true,
				[ this.className ]: !!this.className,
			};
		},
		completionStyle() {
			const completed = Math.min( this.percentCompleted, 100 );
			return `width:${ completed }%`;
		},
		progressionStyle() {
			const progressed = Math.min( this.percentProgressed, 100 );
			return `left:${ progressed }%`;
		},
		showPercentOnRight() {
			return this.showPercent && this.percentPosition === Position.RIGHT;
		},
		showPercentOnLeft() {
			return this.showPercent && this.percentPosition === Position.LEFT;
		},
	},
};
</script>

<style lang="scss" scoped>
.teaming-progress-bar {
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.teaming-progress-bar__progress-bar {
	color: $progress-bar-color;
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 0.6rem;
	position: relative;
	flex: 1;
}

.teaming-progress-bar__outer-bar {
	background-color: $progress-bar-outer-background-color;
	border-radius: 0.2rem;
	height: 0.6rem;
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
}

.teaming-progress-bar__inner-bar {
	background-color: $progress-bar-inner-background-color;
	border-radius: 0.2rem;
	bottom: 0.2rem;
	display: inline-block;
	height: 0.6rem;
	position: absolute;
	left: 0;
	top: 0;
}

.teaming-progress-bar__percent {
	@include font-and-line-for(0);
	color: $progress-bar-percent-color;
	padding-left: 0.3125rem;
}

.teaming-progress-bar__percent--left {
	padding-right: 0.3125rem;
}

.teaming-progress-bar__percent--right {
	padding-left: 0.3125rem;
}

.teaming-progress-bar__progress {
	background-color: transparent;
	border-right: 0.125rem solid $progress-bar-progress-color;
	display: inline-block;
	height: 1.2rem;
	position: absolute;
	left: 0;
	top: -0.3rem;
}
</style>
